// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes modalWarning_rotate__wqbDF {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.modalWarning_body__1Tccg {\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n}\n\n.modalWarning_title__2WXJ2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  flex: 1;\n  padding: 20px;\n}\n\n.modalWarning_footer__3q6mG {\n  height: 80px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}", ""]);
// Exports
exports.locals = {
	"body": "modalWarning_body__1Tccg",
	"title": "modalWarning_title__2WXJ2",
	"footer": "modalWarning_footer__3q6mG",
	"rotate": "modalWarning_rotate__wqbDF"
};
module.exports = exports;
